import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class CamionSucursalService {

  constructor(private gqlclient: GraphQLClient) { }

  obtenerCamionSucursalxRutEmpresaSucursal(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $tipobusqueda: Int) {
          camion_sucursal {
            obtenerCamionSucursalxRutEmpresaSucursal(rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: $tipobusqueda) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  patente
                  descripcion
                  volumen
                  peso_maximo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.camion_sucursal.obtenerCamionSucursalxRutEmpresaSucursal
        // Asegurar que respuesta tenga registros válidos
        if (respuesta && !respuesta.registros) {
          respuesta.registros = [];
        }
        callback({ mensajes, respuesta })
      }
    );
  }
}
